const _formatCourse = course => {
  let track
  let vendor = {
    title: '',
  }
  let presenter = {
    full_name: '',
    image: '',
  }
  let ratings = null
  let files = null
  let groups = null
  let difficulties = null
  const courseVideos = []
  const courseQuizzes = []
  if (course.track && course.track.data) {
    track = course.track.data
    if (course.track.data.vendor && course.track.data.vendor.data) {
      vendor = course.track.data.vendor.data
      track = { ...track, vendor }
    }
  } else {
    track = { vendor }
  }
  if (course.presenter && course.presenter.data) {
    presenter = course.presenter.data
  }
  if (course.files && course.files.data) {
    files = course.files.data.map(file => file)
  }
  if (course.difficulties && course.difficulties.data) {
    difficulties = course.difficulties.data
  }
  if (course.allRatings && course.allRatings.data) {
    ratings = course.allRatings.data
  }
  if (course.groups && course.groups.data) {
    groups = course.groups.data.map(group => {
      let topics = null
      if (group.topics && group.topics.data) {
        topics = group.topics.data.map(topic => {
          let levels = null
          if (topic.levels && topic.levels.data) {
            levels = topic.levels.data.map(level => {
              let videos = null
              let quizzes = null
              if (level.videos && level.videos.data) {
                videos = level.videos.data.map(video => video)
                courseVideos.push(...videos)
              }
              if (level.quizzes && level.quizzes.data) {
                quizzes = level.quizzes.data
                courseQuizzes.push(...quizzes)
              }
              return { ...level, videos, quizzes }
            })
          }
          return { ...topic, levels }
        })
      }
      return { ...group, topics }
    })
  }
  return {
    ...course,
    track,
    presenter,
    files,
    difficulties,
    ratings,
    groups,
    videos: courseVideos,
    quizzes: courseQuizzes,
  }
}

const _formatCourses = response => {
  return response.map(course => _formatCourse(course))
}

const _formatPlaylists = playlist => {
  return playlist.data
}

const _formatPlaylist = playlist => {
  const selectedPlayist = _formatPlaylists(playlist)
  let groups = null
  if (selectedPlayist.groups && selectedPlayist.groups.data) {
    groups = selectedPlayist.groups.data.map(group => {
      let courses = null
      if (group.courses && group.courses.data) {
        courses = _formatCourses(group.courses.data)
      }
      return { ...group, courses }
    })
  }
  return { ...selectedPlayist, groups }
}

export { _formatCourse, _formatCourses, _formatPlaylists, _formatPlaylist }
